import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest, finalize, map, of, startWith, Subscription, tap } from 'rxjs';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';

@Component({
  selector: 'app-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.scss']
})
export class ReportFilterComponent implements OnInit {

  @Output('submit') public readonly submit = new EventEmitter<ReportFilterInterface>();
  @Input('fg') public fg?: FormGroup<ReportFilterFormGroup>;

  public readonly yearList$ = new BehaviorSubject<number[]>([...Array(30).fill(0).map((_, i) => new Date().getFullYear() - i)]);
  public readonly monthList$ = new BehaviorSubject<{ name: string, number: number }[]>([...Helper.date.monthList.long.map((v, i) => ({ name: v, number: i + 1 }))]);
  public readonly toYearList$ = new BehaviorSubject<number[]>((Helper.array.makeArrayOfNumber(new Date().getFullYear() - 3, new Date().getFullYear())).reverse());

  public readonly prompt = Helper.newPromptMessage();

  constructor(

  ) { }

  public ngOnInit(): void {
    const fg = this.fg;

    if (!fg) return;
    const fgValueChanges: Subscription = combineLatest([
      fg.valueChanges.pipe(startWith(fg.value)),
    ]).pipe(
      finalize(() => fgValueChanges.unsubscribe()),
    ).subscribe(() => this.onSubmit());

    const YearStart = fg.controls.YearStart;
    const YearEnd = fg.controls.YearEnd;

    if (!YearStart) return;
    if (!YearEnd) return;

    const subsYearStart: Subscription = YearStart.valueChanges.pipe(
      finalize(() => subsYearStart.unsubscribe()),
    ).subscribe(yearStart => {
      if (!yearStart) return;
      this.toYearList$.next(Helper.array.makeArrayOfNumber(yearStart, new Date().getFullYear()).reverse());

      const yearEnd = YearEnd.value;
      if (!yearEnd) return;
      if (yearStart >= yearEnd) YearEnd.patchValue(undefined);
    });

    this
  }

  public onSubmit() {
    const formData = { ...this.fg?.value };
    if (Helper.getInvalidControls(this.fg).length) {
      this.prompt.set(Helper.errorMessage.requiredFields);
      return;
    }

    this.prompt.clear();
    this.submit.emit(formData);
  }

}

export interface ReportFilterInterface {
  GenerateBy?: string | undefined | null,
  YearStart?: number | undefined | null,
  YearEnd?: number | undefined | null,
  Year?: number | undefined | null,
  Month?: number | undefined | null,
}

interface ReportFilterFormGroup {
  GenerateBy: FormControl<string | undefined | null>,
  YearStart: FormControl<number | undefined | null>,
  YearEnd: FormControl<number | undefined | null>,
  Year: FormControl<number | undefined | null>,
  Month: FormControl<number | undefined | null>,
}